import { AreaChart, Landmark, Layers3, UsersRound } from "lucide-react";
import { IoLocationOutline } from "react-icons/io5";
import { CgShoppingBag } from "react-icons/cg";
import { roles } from "../roles";

export const navigationLinks = [
	{
		label: "Dashboard",
		linkUrl: "/pages",
		icon: AreaChart,
		roles: [roles.user, roles.admin, roles.trading_partner, roles.portal_user],
	},
	{
		label: "Clients",
		linkUrl: "/pages/client",
		icon: Landmark,
		roles: [roles.admin, roles.portal_user],
	},
	{
		label: "Users",
		linkUrl: "/pages/user",
		icon: UsersRound,
		roles: [roles.admin, roles.portal_user],
	},
	{
		label: "Products",
		linkUrl: "/pages/products",
		icon: CgShoppingBag,
		roles: [roles.admin, roles.portal_user],
	},
	{
		label: "Locations",
		linkUrl: "/pages/locations",
		icon: IoLocationOutline,
		roles: [roles.admin, roles.portal_user],
	},
	{
		label: "Serialization",
		linkUrl: "/pages/serialization",
		icon: Layers3,
		roles: [roles.super_admin]
	}
];
